// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Z-9J","large":"styles_large__3E02Y"};